import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue';
import { gsap } from 'gsap';
import SplitText from 'gsap/SplitText';
import useResize from '@/composables/useResize';


export default /*#__PURE__*/_defineComponent({
  __name: 'LineByLine',
  props: {
  debug: {
    type: Boolean,
    default: false
  },
  closest: {
    type: String,
    default: ''
  },
  tag: {
    type: String,
    default: 'div'
  },
  overflow: {
    type: Boolean,
    default: true
  },
  auto: {
    type: Boolean,
    default: true
  },
  delay: {
    type: Number,
    default: 0
  },
  animated: {
    type: Boolean,
    default: true
  },
  thresold: {
    type: String,
    default: '25%'
  },
},
  setup(__props) {

gsap.registerPlugin(SplitText);

const props = __props

const textSplited = ref<SplitText>()
const textSplitedParent = ref<SplitText>()
const root = ref<HTMLElement>()
const init = ref<boolean>(false)
const played = ref<boolean>(false)

const { registerResize, unregisterResize } = useResize();

onMounted(() => {
  onResize()

  if (props.animated) {
    if (props.auto) onEnter()
  }

  registerResize(onResize);
})

onBeforeUnmount(() => {
  unregisterResize();
})

const onResize = async() => {
  root.value.style.height = null

  if (textSplited.value || textSplitedParent.value) {
    textSplitedParent.value.revert()
    textSplited.value.revert()
  }

  await nextTick()
  
  textSplited.value = new SplitText(root.value, { type: 'lines', linesClass: 'Line' });
  
  if (props.overflow) {
    textSplitedParent.value = new SplitText(root.value, { type: 'lines', linesClass: 'Line__Parent' });
  }

  init.value = true
  if (props.animated as boolean) {
    onEnter()
  }
}

const onEnter = () => {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: props.closest ? root.value.closest(props.closest) : root.value,
      start: `top bottom-=${props.thresold}`,
      // markers: false,
      markers: props.debug,
    }, 
    delay: props.delay as number 
  });

  if (init.value && !played.value) {
    played.value = true
    const $ = gsap.utils.selector(root.value)
      tl.from([$('.Line')], {
        autoAlpha: !props.overflow ? 0 : 1,
        yPercent: (index) => 100 * (index+1),
        duration: 1,
        ease: 'quart.out',
        clearProps: 'all',
      }, 'start')
  }

  return tl
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tag), {
    ref_key: "root",
    ref: root
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 512))
}
}

})